module.exports = __webpack_public_path__ + "static/media/Data_COMO_MONTAR_SUA_STARTUP.595dcd99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Data_COMO_MONTAR_SUA_STARTUP.png
// module id = 50
// module chunks = 0